import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const heading = css`
  margin: 0 0 ${spacing.sm}px;
  ${responsiveText.HEADING.SM};
`;

export const overallRatingContainer = css`
  width: 100%;
  text-align: center;
`;
